/* eslint-disable @typescript-eslint/no-explicit-any */
import api from './axios'

/**
 * Distribuidores que o usuário logado enxerga.
 *
 * A API decide o recorte a partir do token. Antes cada tela repetia o mesmo
 * ramo por papel — `/dist/gestor` para gestor, `/dist` mais
 * `filter(d => Number(d.visualizador) === Number(user.id))` para os demais —
 * e esse filtro estava errado: `visualizador` guarda lista ("3,7,12"), e
 * `Number("3,7,12")` é NaN, então visualizador de mais de um distribuidor não
 * Sempre array, inclusive vazio. Nenhuma tela precisa saber o papel para
 * montar a lista.
 */
let distsCache: { data: any[]; expiresAt: number } | null = null

export const carregarDistribuidores = async (forceRefresh = false): Promise<any[]> => {
  const now = Date.now()
  if (!forceRefresh && distsCache && distsCache.expiresAt > now) {
    return distsCache.data
  }

  try {
    const res = await api.get('/dist')
    const raw = res.data?.data ?? res.data ?? []
    const data = Array.isArray(raw) ? raw : raw ? [raw] : []
    distsCache = { data, expiresAt: now + 120000 } // 2 minutos
    return data
  } catch (err) {
    console.error('Erro ao carregar distribuidores:', err)
    return []
  }
}
